import { Guid } from '@approvalmax/types';
import { domain } from 'modules/data';

export const createStepParticipant = (me: Guid, userId: Guid): domain.RequestStepParticipant => {
    return {
        userId,
        source: domain.RequestStepParticipantOrigin.Manually,
        delegateFor: null,
        enabledAccordingToRule: false,
        required: false,
        addedBy: me,
        decision: domain.RequestStepParticipantDecision.NoResponse,
        decisionDate: null,
        canEdit: false,
        editPermissions: [],
    };
};

export const createStepReviewer = (user: domain.User, me: Guid): domain.RequestReviewer => {
    return {
        ...user,
        addedBy: me,
        source: domain.RequestStepReviewerSource.Manual,
        delegateFor: null,
    };
};
